import React from 'react';
import { Col, Flex, Row } from 'antd';

import CountBadge from '@totem/components/deviceTypes/CountBadge';
import DeviceTypeContainer from '@totem/components/deviceTypes/DeviceTypeContainer';
import DeviceTypeFilters from '@totem/components/deviceTypes/DeviceTypeFilter';
import DeviceTypeTable from '@totem/components/deviceTypes/DeviceTypeTable';
import MergeButton from '@totem/components/deviceTypes/MergeButton';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DeviceTypesPage = () => {
  return (
    <ContentLayout>
      <DeviceTypeContainer>
        <IBCard isCovered>
          <DeviceTypeFilters />
          <br />
          <Row>
            <Col span={12}>
              <Flex justify={'flex-start'} align={'center'}>
                <MergeButton isPrimary />
              </Flex>
            </Col>
            <Col span={12}>
              <Flex justify={'flex-end'} align={'center'}>
                <CountBadge />
              </Flex>
            </Col>
          </Row>
          <br />
          <DeviceTypeTable />
        </IBCard>
      </DeviceTypeContainer>
    </ContentLayout>
  );
};

export default DeviceTypesPage;
